import { useSyncExternalStore } from "react";
import { currentSession } from "@/shared/api/session";

let currentId: string | null | undefined;
const listeners = new Set<() => void>();

export function useHomeConversationId(): string | null {
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function getHomeConversationId(): string | null {
  return getSnapshot();
}

export function resetHomeConversation(): void {
  currentId = null;
  remember(null);
  emit();
}

export function setHomeConversationId(id: string): void {
  currentId = id;
  remember(id);
  emit();
}

function emit() {
  for (const l of listeners) l();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): string | null {
  if (currentId === undefined) currentId = recall();
  return currentId;
}

function remember(id: string | null): void {
  try {
    if (id === null) window.sessionStorage.removeItem(OPEN_CONVERSATION_KEY);
    else window.sessionStorage.setItem(OPEN_CONVERSATION_KEY, JSON.stringify({ user: user(), id }));
  } catch {}
}

function recall(): string | null {
  try {
    const raw = window.sessionStorage.getItem(OPEN_CONVERSATION_KEY);
    if (!raw) return null;
    const stored = JSON.parse(raw) as { user?: unknown; id?: unknown };
    if (typeof stored.id !== "string" || stored.id === "") return null;
    return stored.user === user() ? stored.id : null;
  } catch {
    return null;
  }
}

function user(): string | null {
  return currentSession()?.userId ?? null;
}

const OPEN_CONVERSATION_KEY = "simon.chat.open";
